import $ from 'jquery';
import { $window, $wrapper } from '../variables/variables.js';
import { debounce } from '../functions/functions.js';



$( () => {
	$( '.select' ).each( function() {
		const $select     = $( this );
		const $input      = $select.find( '.select__input' );
		const $head       = $select.find( '.select__head' );
		const $items      = $select.find( '.select__item' );
		const $checkboxes = $select.find( '[type="checkbox"]' );
		let headHeight    = $head.height();

		$window.on( 'resizeWidth', debounce( () => {
			if ( $checkboxes.length ) {
				$head.html( '' );
				headHeight = $head.height();
				setItems();
			}
		} ) );

		function setItem() {
			if ( $checkboxes.length ) {
				return;
			}

			const VAL   = $input.val();
			const $item = VAL ? $items.filter( '[data-value="' + VAL + '"]' ) : $items.first();

			$items.removeClass( 'select__item_active' );
			$item.addClass( 'select__item_active' );
			$input.val( $item.attr( 'data-value' ) );
			$head.text( $item.text() );
		}
		setItem();
		$input.on( 'change update', setItem );

		function setItems() {
			if ( ! $checkboxes.length ) {
				return;
			}

			let items = [];

			$checkboxes.prop( 'checked', false );
			$input.val().split( ',' ).filter( val => val ).forEach( val => {
				const $checkbox = $checkboxes.filter( `[value="${val}"]` );

				$checkbox.prop( 'checked', true );
				items.push( $checkbox.next().text().trim() )
			} );

			if ( ! items.length ) {
				items.push( $head.attr( 'data-head' ) );
			}

			items = items.map( item => `<div class="select__head-item">${item}</div>` ).join( '' );
			$head.html( '' ).append( items );

			let countHiden = 0;

			while ( headHeight < $head.height() ) {
				$select.find( '.select__head-item_count' ).remove();
				$select.find( '.select__head-item' ).last().remove();
				countHiden++;
				
				$head.append( `<div class="select__head-item select__head-item_count">+${countHiden}</div>` );
			}
		}
		setItems();
		$input.on( 'change update', setItems );

		// Показать/скрыть список при клике на селект
		$head.on( 'click', () => {
			$select.toggleClass( 'select_active' );
		} );

		// Скрыть список при клике снаружи селекта
		$wrapper.on( 'click', ( e ) => {
			if ( ! $( e.target ).closest( '.checkbox, .select__head' ).closest( $select ).length ) {
				$select.removeClass( 'select_active' );
				setItem();
			}
		} );

		$items
			// Установить одно значение
			.on( 'click', function() {
				const VAL = $( this ).attr( 'data-value' );

				if ( $input.val() !== VAL ) {
					$input.val( VAL ).trigger( 'change' );
				}
			} )
			// Сменить один выделенный пункт при наведении
			.on( 'mouseenter', function() {
				$items.removeClass( 'select__item_active' );
				$( this ).addClass( 'select__item_active' );
			} );
		
		// Установить несколько значений
		$checkboxes.on( 'change', () => {
			$input.val( $checkboxes.filter( ':checked' ).get().map( checkbox => checkbox.value ).join( ',' ) );
			setItems();
		} );

		// Установить колонки для чекбоксов
		if ( $checkboxes.length ) {
			const PER_COLUMN  = 6;
			const MAX_COLUMNS = 3;

			$select.find( '.select__list' ).css( 'column-count', Math.min( MAX_COLUMNS, Math.max( 1, Math.round( $checkboxes.length / PER_COLUMN ) ) ) );
		}
	} );
} );
